document.addEventListener("DOMContentLoaded", function () {
  // Показать все города
  const showCitiesEl = document.querySelector("#js-show-cities");
  if (showCitiesEl) {
    showCitiesEl.addEventListener("click", function () {
      document.querySelectorAll(".dh-cities__item").forEach(item => item.classList.remove("d-none"));
      this.classList.add("d-none");
      document.querySelector("#js-hide-cities").classList.remove("d-none");
    });
  }

  // Скрыть все города
  const hideCitiesEl = document.querySelector("#js-hide-cities");
  if (hideCitiesEl) {
    hideCitiesEl.addEventListener("click", function () {
      document.querySelectorAll(".dh-cities__item--additional").forEach(item => item.classList.add("d-none"));
      this.classList.add("d-none");
      document.querySelector("#js-show-cities").classList.remove("d-none");
    });
  }

  // Переключить аффилиаты по городу
  function filterAffilates(city) {
    document.querySelectorAll(".dh-places__list__item").forEach(item => item.classList.add("d-none"));
    document.querySelectorAll(".dh-places__list__item[data-city='" + city + "']").forEach(item => item.classList.remove("d-none"));

    document.querySelectorAll(".dh-places__select[name='place'] option").forEach(item => item.classList.add("d-none"));
    document.querySelectorAll(".dh-places__select[name='place'] option[data-city='" + city + "']").forEach(item => item.classList.remove("d-none"));
    document.querySelectorAll(".dh-places__select[name='place'] option[value='0']").forEach(item => item.classList.remove("d-none"));
    document.querySelector(".dh-places__select[name='place']").value = "0";
    document.querySelector(".dh-places__list").scrollTop = 0;

    if (document.querySelectorAll(".dh-places__list__item[data-city='" + city + "']").length) {
      googleMap.setCenter({
        lat: Number(
          document.querySelectorAll(".dh-places__list__item[data-city='" + city + "']")
            .first()
            .find(".dh-places__list__item__affiliates__item")
            .first()
            .data("lat")
        ),
        lng: Number(
          document.querySelectorAll(".dh-places__list__item[data-city='" + city + "']")
            .first()
            .find(".dh-places__list__item__affiliates__item")
            .first()
            .data("lng")
        ),
      });
    }
  }

  // Выбрать город
  document.querySelectorAll(".dh-cities__item").forEach(item => item.addEventListener("click", function () {
    if (!this.classList.contains("active")) {
      document.querySelectorAll(".dh-cities__item").forEach(item => item.classList.remove("active"));
      this.classList.add("active");

      document.querySelector("#js-cities").value = this.dataset.city;

      filterAffilates(this.dataset.city);
    }
  }));

  const citiesEl = document.querySelector("#js-cities");
  if (citiesEl) {
    citiesEl.addEventListener("change", function () {
      document.querySelectorAll(".dh-cities__item").forEach(item => item.classList.remove("active"));
      document.querySelector(".dh-cities__item[data-city='" + this.value + "']").classList.add("active");

      filterAffilates(this.value);
    });
  }

  const placesEl = document.querySelector("#js-places");
  if (placesEl) {
    placesEl.addEventListener("change", function () {
    const option = this.querySelector("option:selected");
    if (option.value !== "0") {
      const affiliate = document.querySelector(".dh-places__list__item__affiliates__item[data-id='" + option.value + "']");
      document.querySelector(".dh-places__list").animate({
        scrollTop: affiliate.get(0).offsetTop
        }, 400);
        affiliate.click();
      }
    });
  }

  document.querySelectorAll(".dh-places__list__item__affiliates__item").forEach(item => item.addEventListener("click", function () {
    document.querySelectorAll(".dh-places__list__item__affiliates__item").forEach(item => item.classList.remove("active"));
    this.classList.add("active");

    const marker = googleMarkers.find(
      (marker) =>
        marker.getPosition().lat() === Number(this.dataset.lat) &&
        marker.getPosition().lng() === Number(this.dataset.lng)
    );

    new google.maps.event.trigger(marker, "click");
  }));
});
